import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import CardStats from "components/Cards/CardStats.js";
import { fetchDashboard } from "store/dashboardSlice";

export default function HeaderStats() {
  const dispatch = useDispatch();
  const { total_webinars, total_attendees, total_revenue, loading } = useSelector(
    (state) => state.dashboard
  );

  useEffect(() => {
    dispatch(fetchDashboard());
  }, [dispatch]);

  return (
    <>
      {/* Header */}
      <div className="relative bg-lightBlue-600 md:pt-32 pb-32 pt-12">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div>
            {/* Card stats */}
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="TOTAL WEBINARS"
                  statTitle={loading ? "..." : total_webinars.toString()}
                  statIconName="fas fa-video"
                  statIconColor="bg-red-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="TOTAL ATTENDEES"
                  statTitle={loading ? "..." : total_attendees.toString()}
                  statIconName="fas fa-users"
                  statIconColor="bg-orange-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="TOTAL REVENUE"
                  statTitle={loading ? "..." : `₹${total_revenue}`}
                  statIconName="fas fa-dollar-sign"
                  statIconColor="bg-emerald-500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
